import { create } from '@storybook/theming/create';
import '@mqs/style/style.css';

export default create({
  base: 'light',
  brandTitle: 'Next JS Monorepo Docker',
  brandUrl: 'https://github.com/mqschwanda/nextjs-monorepo-docker',
  brandImage: 'https://storybook.js.org/images/placeholders/350x150.png',
  brandTarget: '_blank',
});
